import { useCallback } from 'react'

export const useFadeNotification = ({
  timer = 4000,
  callback = () => {},
}: {
  timer?: number
  callback: () => void
}) => {
  const execute = useCallback(() => {
    const leaveNotification = setTimeout(() => {
      callback()
    }, timer)

    return () => clearTimeout(leaveNotification)
  }, [callback, timer])
  return { execute }
}
